export const MAX_AUDIO_BYTES = 5 * 1024 * 1024;
export const MAX_RECORD_SECONDS = 60;
export const AUDIO_ACCEPT = ".mp3,.mp4,.mpeg,.mpga,.m4a,.wav,.webm";
const TYPES = ["audio/webm;codecs=opus", "audio/webm", "audio/mp4;codecs=mp4a.40.2", "audio/mp4"];

export const clearRecording = (runtime) => {
  clearInterval(runtime.interval); clearTimeout(runtime.timeout);
  runtime.interval = runtime.timeout = null;
  if (runtime.recorder) {
    runtime.recorder.ondataavailable = runtime.recorder.onstop = runtime.recorder.onerror = null;
    if (runtime.recorder.state !== "inactive") { try { runtime.recorder.stop(); } catch { /* Already stopped. */ } }
  }
  runtime.recorder = null;
  runtime.stream?.getTracks().forEach((track) => track.stop()); runtime.stream = null;
};

export const releaseVoiceInput = (runtime) => {
  runtime.generation++; runtime.controller?.abort(); runtime.controller = null;
  clearRecording(runtime);
  if (runtime.url) URL.revokeObjectURL(runtime.url);
  runtime.url = null; runtime.file = null;
};

export const recordingError = (error) => ({
  NotAllowedError: "Microphone access was not allowed. You can upload an audio clip instead.",
  NotFoundError: "No microphone was found. You can upload an audio clip instead.",
  NotReadableError: "The microphone is busy or unavailable. Please try again.",
}[error.name] || error.message || "Recording could not start. You can upload an audio clip instead.");

export const beginRecording = async (runtime, update, onClip) => {
  const generation = runtime.generation;
  const current = () => generation === runtime.generation;
  if (!window.isSecureContext || !navigator.mediaDevices?.getUserMedia || !window.MediaRecorder) {
    update({ phase: "idle", error: "Recording is unavailable in this browser. You can upload audio instead." }); return;
  }
  const mimeType = TYPES.find((type) => window.MediaRecorder.isTypeSupported(type));
  if (!mimeType) { update({ phase: "idle", error: "This browser cannot record a supported format. You can upload audio instead." }); return; }
  update({ phase: "requesting", error: "", seconds: 0 });
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: { echoCancellation: true, noiseSuppression: true }, video: false });
    if (!current()) { stream.getTracks().forEach((track) => track.stop()); return; }
    runtime.stream = stream;
    const recorder = new window.MediaRecorder(stream, { mimeType, audioBitsPerSecond: 64000 });
    runtime.recorder = recorder;
    const chunks = []; let bytes = 0;
    recorder.ondataavailable = (event) => {
      if (!current() || !event.data.size) return;
      bytes += event.data.size;
      if (bytes > MAX_AUDIO_BYTES) { clearRecording(runtime); update({ phase: "idle", error: "Recording is too large. Please record a shorter question." }); return; }
      chunks.push(event.data);
    };
    recorder.onerror = () => { if (current()) { clearRecording(runtime); update({ phase: "idle", error: "Recording stopped unexpectedly. Please try again." }); } };
    recorder.onstop = () => {
      if (!current()) return;
      const actualType = recorder.mimeType || mimeType;
      clearRecording(runtime);
      const extension = actualType.includes("mp4") ? "mp4" : "webm";
      const clip = new File(chunks, `question.${extension}`, { type: actualType });
      if (clip.size < 100) { update({ phase: "idle", error: "The recording is empty. Please try again." }); return; }
      onClip(clip);
    };
    recorder.start(250); const started = Date.now();
    update({ phase: "recording" });
    runtime.interval = setInterval(() => { if (current()) update({ seconds: Math.min(60, Math.floor((Date.now() - started) / 1000)) }); }, 250);
    runtime.timeout = setTimeout(() => { if (current() && recorder.state === "recording") recorder.stop(); }, MAX_RECORD_SECONDS * 1000);
  } catch (error) { if (current()) { clearRecording(runtime); update({ phase: "idle", error: recordingError(error) }); } }
};